import React, { Component } from 'react';
import axios from 'axios';
import {
    Typography,
    withStyles,
    CircularProgress,
    Button
} from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import { Auth } from 'aws-amplify';
import ContentHeader from '../components/ContentHeader';
import globalStyles from '../styles';

const styles = theme => ({
    root: {
        border: '0',
        maxWidth: '600px',
        margin: '40px auto',
        position: 'relative',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 10px'
        }
    },
    innerRoot: {
        textAlign: 'center',
        border: '0',
        maxWidth: '600px',
        margin: '40px auto',
        position: 'relative',
        background: '#fff',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.21)',
        [theme.breakpoints.down('sm')]: {
            maxWidth: '100%',
            margin: '20px 10px'
        }
    },
    error: {
        margin: '20px 0 0 5px',
        color: red[500],
        minHeight: '20px'
    },
    spinner: {
        marginTop: '60px'
    },
    button: {
        minHeight: '40px',
        marginTop: '10px',
        marginBottom: '10px'
    },
    inner: {
        padding: '20px 10px'
    },
    link: {
        ...globalStyles.link,
        fontWeight: 'bold'
    },
    paragraph: {
        fontSize: '16px',
        marginBottom: '10px',
        fontWeight: '100'
    }
});

class CreateMandate extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mandateSession: null,
            error: '',
            isLoading: true
        };
    }

    async componentDidMount() {
        const {
            match: {
                params: { clientId, serviceId, ticketId, renewalId, year }
            }
        } = this.props;

        const mandateSession = await this.postMandateSession(
            clientId,
            serviceId,
            ticketId,
            year,
            renewalId
        );

        this.setState({
            mandateSession,
            isLoading: false
        });
    }

    async postMandateSession(clientId, serviceId, ticketId, year, renewalId) {
        try {
            const currentSession = await Auth.currentSession();

            const headers = {
                Authorization: currentSession.getIdToken().getJwtToken()
            };

            const response = await axios.post(
                `${process.env.REACT_APP_PAYMENT_API_ENDPOINT}/customer-mandate-session/client/${clientId}`,
                {
                    service_id: serviceId,
                    ticket_id: ticketId,
                    year,
                    renewal_id: renewalId
                },
                {
                    headers
                }
            );

            return response.data;
        } catch (e) {
            this.setState({
                error:
                    'There was a problem whilst trying to establish a session for a new direct debit mandate. Please try again later or contact support if this issue continues.'
            });
            return null;
        }
    }

    render() {
        const { classes } = this.props;
        const { mandateSession, error, isLoading } = this.state;

        return (
            <div className={classes.root}>
                <div className={classes.innerRoot}>
                    <ContentHeader
                        text="Setup direct debit mandate"
                        id="create-mandate-heading"
                    />
                    <div className={classes.inner}>
                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            This ticket requires payment using Direct Debit.
                        </Typography>
                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            To get started, you need a Direct Debit mandate with
                            your Transport Provider. After creating your mandate
                            below, you will return to ShuttleID to buy your
                            ticket.
                        </Typography>

                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            When you are redirected back to ShuttleID, you will
                            provide the passenger details, apply any voucher
                            codes that you have, and confirm the order.
                        </Typography>

                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            <strong>IMPORTANT!</strong>
                        </Typography>

                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            If you exit the process immediately after creating
                            your mandate, you will not have a ticket and
                            payments will not be scheduled.
                        </Typography>

                        {/* <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            After the mandate is set up, you will be able to add
                            the passenger details, apply a voucher code if you
                            have one, and confirm the order.
                        </Typography>

                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            Please note creating a direct debit mandate does not
                            confirm your order and will not give you a ticket.
                            Your order is only confirmed after supplying the
                            passenger details and confirming the payment
                            schedule.
                        </Typography> */}

                        <Typography
                            className={classes.paragraph}
                            variant="body1"
                        >
                            <a
                                className={classes.link}
                                href="https://help.shuttleid.uk/en/articles/7852300-how-to-buy-a-ticket-using-direct-debit"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Help buying your ticket with Direct Debit
                            </a>
                        </Typography>

                        {isLoading && (
                            <CircularProgress
                                id="loading-spinner"
                                className={classes.spinner}
                            />
                        )}

                        {!isLoading && mandateSession !== null && (
                            <p>
                                <a
                                    style={{ textDecoration: 'none' }}
                                    href={mandateSession.redirect_url}
                                >
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        className={classes.button}
                                    >
                                        Setup direct debit mandate
                                    </Button>
                                </a>
                            </p>
                        )}

                        {!isLoading && error !== '' && (
                            <Typography
                                className={classes.paragraph}
                                variant="body2"
                                style={{ color: 'red' }}
                            >
                                {error}
                            </Typography>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(CreateMandate);
